export function faq() {
  $(function () {
    function toggleAccordion() {
      var $nextContent = $(this).next('.ac_content');
      if ($nextContent.hasClass('is-active')) {
        $nextContent.slideUp();
        $(this).removeClass('is-active');
        $nextContent.removeClass('is-active');
      } else {
        $nextContent.slideDown();
        $(this).addClass('is-active');
        $nextContent.addClass('is-active');
      }
    }
    $(document).on('click', '.ac_heading', toggleAccordion);
  });
}